import React from 'react';
import { Modal, OverlayTrigger, Button } from 'react-bootstrap';

export default class AboutUs extends React.Component {
  render() {
    return <Modal show={this.props.show} onHide={this.props.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>About Us</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <p>Evolution - We all have seen different civic-environmental issues in our neighbourhoods. For us, anyone (we focus on youth) who tries to solve these issues is a Solve Ninja. While doing a Discover-The-Issue activity, Solve Ninjas realized a need to have a dashboard where they could map and view information to understand what was happening in their neighbourhood. This information could be about</p>
          <ul>
           <li>Local governance (Corporator, MLA, MP)</li>
           <li>Waste-Water-Energy-Sanitation</li>
           <li>Municipality representative offices</li>
           <li>Public infrastructures like dry waste collection centres or composting centres or toilets</li>
           <li>Issues like black spots (where people are dumping waste)/spots where people might be urinating in the open/water leakages</li>
           <li>Air Quality</li>
           <li>Education data</li>
           <li>Potholes etc</li>
          </ul>
          <p>This is our first attempt in this direction.</p>
          <p>Progress so far</p>
          <ul>
           <li>Data mapped for Bengaluru, but with elections around the corner, information is about to change</li>
           <li>Issues are not mapped. We need your help here!</li>
           <li>Most of the representative office mapped, map locations are being uploaded</li>
           <li>Submit form for the information you want to contribute is up</li>
          </ul>
          <p>Next Steps</p>
          <ul>
            <li>Collect user feedback and increase the quality of this dashboard</li>
            <li>Add more data, help us here!</li>
            <li>Add more cities</li>
          </ul>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.props.handleClose}>Close</Button>
          </Modal.Footer>
        </Modal>;
  }
}



// WEBPACK FOOTER //
// ./src/components/common/AboutUs.js